/**
 * User: Faris
 * Date: 6/24/13
 * Time: 4:30 PM
 */

define('app/views/header',['require'],function(require) {

  return Backbone.View.extend({

    navOpen: false,
    bookingOpen: false,
    arrival: '',
    departure: '',
    
    initialize: function(){
      var _self = this;
    },

    update: function(model){
    },

    close: function(){
      this.navOpen = false;
    }
  });
});

